import { render, staticRenderFns } from "./DialogFaq.vue?vue&type=template&id=d3fb4c76&"
import script from "./DialogFaq.vue?vue&type=script&lang=js&"
export * from "./DialogFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports